import { DialogActions, DialogActionsProps } from '@mui/material';
import useViewportMode, { ViewportMode } from '../../hooks/useViewportMode';

export interface StickyDialogActionsProps extends DialogActionsProps {
    phoneLayout?: 'stacked' | 'inline';
    viewportOverride?: ViewportMode;
    'data-testid'?: string;
}

const StickyDialogActions = ({
    phoneLayout = 'stacked',
    viewportOverride,
    'data-testid': dataTestId = 'sticky-dialog-actions',
    sx,
    ...actionsProps
}: StickyDialogActionsProps) => {
    const viewport = useViewportMode();
    const mode = viewportOverride ?? viewport.mode;
    const isPhone = mode === 'phone';
    const isTablet = mode === 'tablet';

    return (
        <DialogActions
            {...actionsProps}
            data-testid={dataTestId}
            sx={{
                position: 'sticky',
                bottom: 0,
                zIndex: 2,
                flex: '0 0 auto',
                bgcolor: 'background.paper',
                borderTop: 1,
                borderColor: 'divider',
                ...(isPhone && {
                    px: 2,
                    pt: 1.5,
                    pb: 'calc(12px + env(safe-area-inset-bottom, 0px))',
                    alignItems: 'stretch',
                    flexDirection: phoneLayout === 'stacked' ? 'column' : 'row',
                    gap: 1,
                    '& > :not(:first-of-type)': { marginLeft: 0 },
                    '& > .MuiButtonBase-root': {
                        minHeight: 44,
                        ...(phoneLayout === 'stacked' && { width: '100%' }),
                    },
                }),
                ...(isTablet && {
                    flexWrap: 'wrap',
                    gap: 1,
                    '& > :not(:first-of-type)': { marginLeft: 0 },
                    '& > .MuiButtonBase-root': { minHeight: 44 },
                }),
                ...sx,
                ...(isPhone && {
                    paddingBottom: 'calc(12px + env(safe-area-inset-bottom, 0px))',
                }),
            }}
        />
    );
};

export default StickyDialogActions;
